"use client";

import Typography from "@mui/material/Typography";
import MuiLink from "@mui/material/Link";
import Link from "next/link";
import Box from "@mui/material/Box";
import LoginComponent from "../../components/LoginComp";
import { useSnackbar } from "../../components/SnackbarProvider";
import { useSearchParams } from "next/navigation";

const SignInClientPage = () => {
  const showSnackBar = useSnackbar();
  const searchParams = useSearchParams();

  return (
    <>
      <Box
        sx={{
          display: "flex",
          gap: "1.5rem",
          flexDirection: "column",
          width: "clamp(10rem, 50% , 25rem)",

          "@media screen and (max-width:600px)": {
            width: "100%",
          },
        }}
      >
        <Typography
          sx={{
            mb: "1rem",
          }}
          variant="h5"
          component={"h1"}
        >
          Sign in to{" "}
          <MuiLink
            component={Link}
            sx={{
              textDecoration: "none",
              color: "inherit",
              "&:hover": {
                textDecoration: "underline",
              },
            }}
            href="/"
          >
            Inkscribe
          </MuiLink>
        </Typography>
        <LoginComponent
          showSnackbar={showSnackBar}
          redirectURL={searchParams.get("next") || "/dashboard"}
          redirectOnSuccess
        />
        <Typography
          component={"div"}
          sx={{
            color: "InactiveCaptionText",
          }}
        >
          {"Don't"} have an account?{" "}
          <MuiLink component={Link} href="/sign-up">
            Sign up
          </MuiLink>
        </Typography>
      </Box>
    </>
  );
};

export default SignInClientPage;
